import React, { useState } from 'react';
import CaretUp from '../Icons/CaretUp';
import CaretDown from '../Icons/CaretDown';
import CollapsibleItemStyles from './styled';
import theme from '../../../styles/theme';

const CollapsibleItem = ({
  title = '',
  children,
  iconColor = theme.colors.bedtime,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const clickHandler = () => {
    setIsOpen(prev => !prev);
  };
  return (
    <CollapsibleItemStyles>
      <div className='container' onClick={clickHandler}>
        <div className='title'>{title}</div>
        <div className='chevronContainer'>
          {!isOpen ? (
            <CaretDown className='caret-down' height={20} color={iconColor} />
          ) : (
            <CaretUp className='caret-up' height={20} color={iconColor} />
          )}
        </div>
      </div>
      <div className='content'>{isOpen && <p>{children}</p>}</div>
    </CollapsibleItemStyles>
  );
};

export default CollapsibleItem;
